module.exports = __webpack_public_path__ + "static/media/alpha_23.b77f267a.png";